import * as React from 'react';

/**
 * @description Georgia icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Georgia } from '@sravni/design-system-icons'
 *
 * <Georgia />
 * ```
 */
const Georgia = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "Georgia", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("g", { clipPath: "url(#Georgia__a)" },
        React.createElement("g", { clipPath: "url(#Georgia__b)" },
            React.createElement("rect", { width: "20", height: "20", rx: "10", fill: "#fff" }),
            React.createElement("path", { d: "M3.863 3.97c.311.04.627.04.938 0-.18.9-.18 1.827 0 2.727a3.6 3.6 0 0 0-.938 0c.18-.9.18-1.827 0-2.728Z", fill: "red" }),
            React.createElement("path", { d: "M5.697 4.864a3.6 3.6 0 0 0 0 .938c-.9-.18-1.827-.18-2.728 0a3.6 3.6 0 0 0 0-.938c.9.181 1.828.181 2.728 0ZM15.197 3.969c.312.04.627.04.938 0-.18.9-.18 1.828 0 2.728a3.6 3.6 0 0 0-.938 0c.18-.9.18-1.828 0-2.728Z", fill: "red" }),
            React.createElement("path", { d: "M17.031 4.864c-.04.311-.04.627 0 .938-.9-.18-1.827-.18-2.728 0 .041-.311.041-.627 0-.938.9.18 1.828.18 2.728 0ZM3.863 13.97c.311.04.627.04.938 0-.18.9-.18 1.827 0 2.727a3.606 3.606 0 0 0-.938 0c.18-.9.18-1.827 0-2.728Z", fill: "red" }),
            React.createElement("path", { d: "M5.697 14.864a3.6 3.6 0 0 0 0 .938c-.9-.18-1.827-.18-2.728 0a3.6 3.6 0 0 0 0-.938c.9.181 1.828.181 2.728 0ZM15.197 13.969c.312.04.627.04.938 0-.18.9-.18 1.828 0 2.728a3.598 3.598 0 0 0-.938 0c.18-.9.18-1.828 0-2.728Z", fill: "red" }),
            React.createElement("path", { d: "M17.031 14.864c-.04.311-.04.627 0 .938-.9-.18-1.827-.18-2.728 0 .041-.311.041-.627 0-.938.9.18 1.828.18 2.728 0ZM8 0h4v20H8z", fill: "red" }),
            React.createElement("path", { fill: "red", d: "M20 8v4H0V8z" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "Georgia__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" })),
        React.createElement("clipPath", { id: "Georgia__b" },
            React.createElement("rect", { width: "20", height: "20", rx: "10", fill: "#fff" }))))));

export { Georgia };
//# sourceMappingURL=Georgia.js.map
